<template>
  <div class="admin-tab-content">
    <div class="tab-header">
      <h2>🚀 Configuración Rocket</h2>
      <p class="description">Configura el modo de operación del sistema Rocket</p>
    </div>

    <div class="control-section">
      <label for="rocket-mode">Modo Cohete:</label>
      <select id="rocket-mode" v-model="rocketSetting" class="admin-select">
        <option :value="1">Normal</option>
        <option :value="2">Sin-Selección</option>
        <option :value="3">Sin-Enlace</option>
        <option :value="4">Solo Activo Trade</option>
      </select>
      <p class="help-text">Seleccione el modo rocket: Normal (1), Sin-Selección (2), Sin-Enlace (3), o Solo Activo Trade (4)</p>
    </div>

    <div class="action-section">
      <button @click="saveSettings" class="btn-primary" :disabled="saving">
        {{ saving ? 'Guardando...' : 'Guardar Configuración' }}
      </button>
    </div>

    <div v-if="message" :class="['message-box', messageType]">
      {{ message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RocketSettingsTab',
  data() {
    return {
      rocketSetting: 1,
      saving: false,
      message: '',
      messageType: ''
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/broker/rocket-setting`);
        if (response.data.success) {
          this.rocketSetting = parseInt(response.data.value);
        }
      } catch (error) {
        console.error('Error loading rocket settings:', error);
      }
    },
    async saveSettings() {
      this.saving = true;
      this.message = '';

      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/broker/rocket-setting/${this.rocketSetting}`);

        if (response.data.success) {
          this.message = 'Configuración guardada correctamente';
          this.messageType = 'success';

          setTimeout(() => {
            this.message = '';
          }, 3000);
        } else {
          this.message = response.data.message || 'Error al guardar la configuración';
          this.messageType = 'error';
        }
      } catch (error) {
        this.message = 'Error al guardar la configuración';
        this.messageType = 'error';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.admin-tab-content {
  padding: 20px;
}

.tab-header h2 {
  color: #3498db;
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  color: #bbb;
  margin-bottom: 30px;
}

.control-section {
  margin-bottom: 20px;
}

.control-section label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #e6e6e6;
}

.admin-select {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 0 10px;
  width: 100%;
  max-width: 300px;
}

.help-text {
  color: #aaa;
  font-size: 13px;
  margin-top: 5px;
}

.action-section {
  margin-top: 20px;
}

.btn-primary {
  background: #3498db;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 20px;
  transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
  background: #2980b9;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.message-box {
  background-color: #333;
  border-radius: 4px;
  margin-top: 15px;
  padding: 10px;
  border-left: 3px solid #3498db;
}

.message-box.success {
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.message-box.error {
  border-left-color: #e74c3c;
  color: #e74c3c;
}
</style>
